import { Fancybox } from "@fancyapps/ui";
import "lazysizes";
import "js-cloudimage-360-view";

// this is triggered when opening the fancybox from the big image
function openFancyboxFromImage() {
    Fancybox.fromOpener('[data-fancybox="gallery"]', {
        startIndex: startIndex,
        on: {
            done: (fancybox, slide) => {
                addClassToThumbnails();
                showInlineContent();
                pauseVideoOnChangeSlide();
            },
            initCarousel: (fancybox, slide) => {
                addClassToThumbnails();
            },
            shouldClose: (fancybox, slide) => {
                hideInlineContent();
                closeVideo();
            },
        },
    });
}

// Init the first element to avoid click issue
const imageSlidesContainer = document.querySelector(".imageSlidesContainer");
if (imageSlidesContainer !== null) {
    const thumbs = imageSlidesContainer.querySelectorAll(".thumbnail");
    if (thumbs.length > 0 && thumbs[0].classList.contains("isImage")) {
        thumbs[0].classList.add("active");
    }
}

const showInlineContent = () => {
    const fancyContainer = document.querySelector(".fancybox__container");
    if (fancyContainer?.classList.contains("hidden")) {
        fancyContainer?.classList.remove("hidden");
    }
};

const hideInlineContent = () => {
    const fancyContainer = document.querySelector(".fancybox__container");
    fancyContainer?.classList.add("hidden");
};

//for pausing videos with autoplay
const pauseVideoOnChangeSlide = () => {
    const youtubeVideos = document.querySelectorAll(".container-video iframe");

    if (youtubeVideos != null) {
        youtubeVideos.forEach((video) => {
            video.src = video.src.replace("autoplay=1", "autoplay=0");

            const closestSlideIndex = video.closest(".fancybox__slide")?.getAttribute("data-index");
            let carouselThumbIsSelected = document
                .querySelector('.carousel__slide[data-index="' + closestSlideIndex + '"]')
                ?.classList.contains("is-nav-selected");

            if (carouselThumbIsSelected) {
                video.src = video.src.replace("autoplay=0", "autoplay=1");
            }
        });
    }
};

const closeVideo = () => {
    const youtubeVideos = document.querySelectorAll(".container-video iframe");
    if (youtubeVideos != null) {
        youtubeVideos.forEach((video) => {
            video.src = video.src.replace("autoplay=1", "autoplay=0");
        });
    }
};

//adding 360 class/icon to thumbnails in fancybox thumbnails
const addClassToThumbnails = () => {
    thumbnailsList.forEach((thumb, i) => {
        let carouselThumb = document.querySelector('.carousel__slide[data-index="' + i + '"]');
        if (thumb != null && thumb.classList.contains("thumbnail-360")) {
            carouselThumb?.classList.add("thumbnail-360");
        }
    });
};

let startIndex = 0;
const thumbnailsList = document.querySelectorAll(".thumbnail");
const thumbnails = document.querySelectorAll(".thumbnail img");
const mainImage = document.querySelector(".mainImageContainer img");
const mainImageContainer = document.querySelector(".mainImageContainer");

mainImageContainer.addEventListener("click", (e) => {
    e.preventDefault();
    openFancyboxFromImage();
});

//Changing mainImage when clicking on thumbnail images
if (thumbnails !== null) {
    thumbnails.forEach((thumb, i) => {
        const index = i;
        const isImage = thumb.classList.contains("isImage");

        thumb.addEventListener("click", (e) => {
            e.preventDefault();

            if (isImage) {
                thumbnails.forEach((thumb2) => {
                    thumb2.classList.remove("active");
                    thumb2.parentElement.classList.remove("active");
                });

                thumb.classList.add("active");
                thumb.parentElement.classList.add("active");
                mainImage.classList.add("transition");
            }

            setTimeout(() => {
                // This code changes the main image, and we dont want to change
                // the main image if the thumb is a 360 image or a video
                if (isImage) {
                    let parent = mainImage.parentElement;
                    parent.dataset.caption = thumb.dataset.caption ?? "";

                    mainImage.src = thumb.getAttribute("data-href");
                    mainImage.classList.remove("transition");
                    mainImage.alt = thumb.alt ?? "";
                }

                // We update the startIndex to open the fancybox from the clicked image
                startIndex = index;

                if (!isImage || (isImage && mainImage.src === thumb.getAttribute("data-href")))
                    openFancyboxFromImage(startIndex);
            }, 300);
        });
    });
}
